var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { ContainerProvider, useContainer } from './ContainerContext.js';
import { CONTAINER_HORIZONTAL_DIRECTIONS, extractDetailFromContainerAlignment, extractDetailFromContainerHide, extractDetailFromContainerMaxSize, extractDetailFromContainerOrder, extractDetailFromContainerPadding, extractDetailFromContainerPaddingAxis, getContainerAlignment, getContainerHide, getContainerMaxSize, getContainerOrder, getContainerPadding, getContainerSpacing, minContainerSize, sumContainerSizes, } from './utils.js';
export const Container = (_a) => {
    var { size, maxSize, childrenSizes = [], direction = 'vertical', grow, shrink, spacing = 'md', padding, alignment, order, hide, opacity, as: Component = 'div' } = _a, _b = _a.containerProps, _c = _b === void 0 ? {} : _b, { className } = _c, containerProps = __rest(_c, ["className"]), { children } = _a;
    const { direction: parentDirection } = useContainer();
    const items = React.Children.toArray(children);
    const gridSize = minContainerSize(size, sumContainerSizes(...childrenSizes));
    return (React.createElement(ContainerProvider, { size: size, direction: direction },
        React.createElement(Component, Object.assign({ className: clsx(!CONTAINER_HORIZONTAL_DIRECTIONS.includes(parentDirection) &&
                'w-full', CONTAINER_HORIZONTAL_DIRECTIONS.includes(parentDirection) && [
                grow === true && 'grow',
                grow === false && 'grow-0',
                shrink === true && 'shrink',
                shrink === false && 'shrink-0',
            ], direction === 'vertical' && 'flex flex-col', direction === 'horizontal' && 'flex flex-row', direction === 'vertical-reverse' && 'flex flex-col-reverse', direction === 'horizontal-reverse' && 'flex flex-row-reverse', direction === 'grid' && [
                'grid grid-cols-1',
                gridSize === 'sm' && 'sm:grid-cols-2',
                gridSize === 'md' && 'md:grid-cols-4',
                gridSize === 'lg' && 'md:grid-cols-6',
                (gridSize === 'xl' || gridSize === 'full') &&
                    'md:grid-cols-6 lg:grid-cols-8',
            ], parentDirection === 'grid' && [
                'col-span-1',
                size === 'sm' && 'sm:col-span-2',
                size === 'md' && 'md:col-span-4',
                size === 'lg' && 'md:col-span-6',
                (size === 'xl' || size === 'full') && 'md:col-span-6 lg:col-span-8',
            ], opacity === 'none' && 'opacity-100', opacity === 'low' && 'opacity-75', opacity === 'medium' && 'opacity-50', opacity === 'high' && 'opacity-25', getContainerMaxSize(extractDetailFromContainerMaxSize(size, maxSize)), getContainerAlignment({
                alignment: extractDetailFromContainerAlignment(alignment),
                direction,
                parentDirection,
            }), getContainerSpacing({
                direction,
                spacing: extractDetailFromContainerPaddingAxis(spacing),
            }), getContainerPadding(extractDetailFromContainerPadding(padding)), getContainerOrder(extractDetailFromContainerOrder(order)), getContainerHide(extractDetailFromContainerHide(hide)), className) }, containerProps), items)));
};
//# sourceMappingURL=Container.js.map